import SectionHeading from "@/components/base/SectionHeading";
import { processSteps } from "@/mocks/home";

export default function Process() {
  return (
    <section id="process" className="relative overflow-hidden bg-primary-950 py-20 md:py-28">
      <div className="grid-texture absolute inset-0 opacity-[0.06]" />
      <div className="absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary-500/20 blur-3xl" />
      <div className="absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-accent-500/10 blur-3xl" />

      <div className="relative mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="How it works"
          tone="dark"
          align="center"
          title="From water to finished steel in four stages"
          description="Green hydrogen replaces coal as the reducing agent, and renewable electricity powers both hydrogen production and the furnace. Melting, casting and rolling join in phase 2."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {processSteps.map((step, index) => (
            <div
              key={step.step}
              className="reveal relative rounded-lg border border-background-50/12 bg-background-50/[0.06] p-6 backdrop-blur transition-colors hover:border-accent-400/50"
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <span className="font-heading text-4xl font-semibold text-background-50/15">{step.step}</span>
              <span className="mt-2 flex h-11 w-11 items-center justify-center rounded-md bg-accent-500/15 text-accent-300">
                <i className={`${step.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-background-50">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-300">{step.description}</p>
              {index < processSteps.length - 1 && (
                <span className="absolute -right-2.5 top-1/2 hidden h-5 w-5 -translate-y-1/2 items-center justify-center text-background-50/30 lg:flex">
                  <i className="ri-arrow-right-s-line text-xl" />
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="reveal mt-12 grid grid-cols-1 gap-5 rounded-xl border border-background-50/12 bg-background-50/[0.04] p-6 md:grid-cols-3 md:p-8">
          {[
            { icon: "ri-temp-cold-line", value: "1,600–1,700°C", label: "Electric arc melting temperature" },
            { icon: "ri-gas-station-line", value: "H₂", label: "Reducing agent, not coal" },
            { icon: "ri-leaf-line", value: "Near zero", label: "CO₂ at the reduction step" },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-4">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-500/20 text-primary-200">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <span>
                <span className="block font-heading text-2xl font-semibold text-background-50">{item.value}</span>
                <span className="block text-xs uppercase tracking-wider text-background-300">{item.label}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}